import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { bell, notify } from '../../atomstore/store';

const FootprintNotification = () => {
    const [notification, setNotification] = useAtom(notify);
    const [, setBellStatus] = useAtom(bell);

    const navigate = useNavigate();

    useEffect(() => {
        if (notification?.subtitle) {
            const timer = setTimeout(() => {
                setNotification({ title: '', subtitle: '' });
            }, 8000);

            return () => clearTimeout(timer);
        }
    }, [notification, setNotification]);

    if (!notification?.subtitle) return null;

    const {
        title = 'Footprints Childcare',
        subtitle,
    } = notification;

    const handleClick = () => {
        setBellStatus(false)
        setNotification({ title: '', subtitle: '' });
        navigate('/notifications');
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 ">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/40 " />

            {/* Notification Card */}
            <div
                onClick={handleClick}
                className="
                    relative z-10
                    w-full
                    min-w-[280px]
                    max-w-sm
                    sm:max-w-md
                    lg:max-w-lg

                    bg-white
                    rounded-3xl
                    shadow-2xl
                    border border-gray-100
                    overflow-hidden
                    animate-slide-up
                    cursor-pointer
                "
            >
                {/* Header */}
                <div className="bg-gradient-to-r from-cyan-500 to-blue-600 px-5 py-4 flex items-center gap-3 min-w-0">
                    <div className="bg-white/20 p-2 rounded-xl flex-shrink-0">
                        <Bell className="w-5 h-5 text-white" />
                    </div>

                    <h3 className="text-white font-semibold text-base truncate max-w-full">
                        {title}
                    </h3>
                </div>

                {/* Body */}
                <div className="p-4 flex gap-4 items-start min-w-0">
                    <img
                        src={require('../../assets/splash-nico-hi.png')}
                        alt="Footprints"
                        className="w-10 h-10 rounded-2xl object-contain bg-gray-50 flex-shrink-0"
                    />

                    <p className="text-gray-700 text-sm leading-snug line-clamp-3">
                        {subtitle}
                    </p>
                </div>

                {/* Footer */}
                <div className="px-4 pb-4 text-xs text-gray-400 text-right">
                    Tap to view details
                </div>
            </div>
        </div>
    );
};

export default FootprintNotification;
